import { getPlayerAPI } from '../initSkin';
import { getTypeOfContent } from './getTypeOfContent';

export function updateInteractiveTime(playerState) {
  const {
    program: interactiveChannelPlayingProgram,
    channel,
    currentProgram: airProgram,
    programPosition: interactiveProgramPosition,
    epgCurrentTimestamp,
    currentTime,
    livePosition,
    stream,
  } = playerState;

  const type = getTypeOfContent(stream);
  let interactivePosition;

  switch (type) {
    case 'tv':
      if (channel) {
        if (channel.isInteractive && interactiveChannelPlayingProgram) {
          // M-channels or dvr-channel
          if (interactiveProgramPosition >= 1) {
            interactivePosition = interactiveProgramPosition;
          }
        } else if (!channel.isLocked) {
          // regular linear channel or channel without program
          const { startTimestamp = 0 } = airProgram || {};
          interactivePosition = epgCurrentTimestamp - startTimestamp;
        }
      }
      break;
    case 'vod':
      interactivePosition = currentTime;
      break;
    case 'live_dvr': {
      interactivePosition = livePosition;
      break;
    }
    case 'live': {
      interactivePosition = Math.round(Date.now() / 1000);
      break;
    }
  }
  getPlayerAPI().playerMethods.setInteractiveTimeData(interactivePosition);
}
